//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import PhotoSwipe from 'photoswipe/dist/photoswipe'
import UI from 'photoswipe/dist/photoswipe-ui-default'
import objectAssign from 'object-assign'
import api from '@/api/api'
import $ from 'jquery'

export default {
  data() {
    return {
      id: '',
      current: 0,
      showPositionValue: false,
      position: 'default',
      img_list: []
    }
  },
  computed: {
    interact() {
      return this.data[this.index]
    }
  },
  methods: {
    remove() {
      if (confirm('确定删除当前作品么？')) {
        // 调用删除操作
        api.live.removeInteraction(this.interact.Id)
          .then(() => {
            // 删除成功
            this.$emit('refresh')
            this.photoswipe.close()
          })
      }
    },
    init() {
      const self = this
      this._init(0)
    },
    _init(index) {
      const self = this
      let options = objectAssign({
        history: false,
        shareEl: false,
        tapToClose: false,
        index: index
      }, this.options)
      this.photoswipe = new PhotoSwipe(this.$el, UI, this.img_list, options)
      this.photoswipe.init()
      this.photoswipe.listen('close', () => {
        this.$emit('on-close')
      })
    },
    showPosition(position) {
      this.position = position
      this.showPositionValue = true
    },
    direct() {
      let liveId = this.$route.params.liveId
      this.$router.push({
        name: 'userInteractionDetail',
        params: { liveId: liveId, interactionId: this.id }
      })
    },
    show(item, id) {
      this.id = id
      this.img_list = []
      this.img_list.push({
        w: item.w,
        h: item.h,
        src: item.src
      })
      this.init()
    },
    close() {
      this.photoswipe.close()
    }
  },
  props: [
    'list',
    'index',
    'options',
    'data'
  ],
}



// WEBPACK FOOTER //
// ./src/components/XPreview/UPreview.vue